import { FormControl, FormErrorMessage } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { AdminSettings } from "../../types/adminsettings.types";
import Input from "../inputs/Input";
import { useImperativeHandle, forwardRef } from "react";

interface AdminSettingsFormProps {
  value?: AdminSettings | null | undefined;
}

export type AdminSettingsFormHandler = {
  values: () => AdminSettings,
  valid: () => Promise<boolean>,
}

const AdminSettingsForm = forwardRef<AdminSettingsFormHandler, AdminSettingsFormProps>(({ value }, ref) => {
  const methods = useForm();

  useImperativeHandle(ref, () => ({
    valid: () => {
      return methods.trigger();
    },
    values: () => {
      const values = methods.getValues()
      return {
        baseDiscountPercentage: values.baseDiscountPercentage / 100,
        shippingAfter: values.shippingAfter,
        upsShippingPrice: values.upsShippingPrice * 100,
        upsSageId: values.upsSageId,
        printingServiceAddress: values.printingServiceAddress,
      }
    }
  }));
  return (
    <FormProvider {...methods}>
      <form style={{ marginTop: "32px" }}>
        <FormControl isInvalid={!!methods.formState.errors.baseDiscountPercentage} mb={4}>
          <Input
            id="baseDiscountPercentage"
            placeholder="Remise refonte (%)"
            defaultValue={value?.baseDiscountPercentage ? value?.baseDiscountPercentage * 100 : 0}
            {...methods.register("baseDiscountPercentage", {
              required: "Ce champ est obligatoire",
            })}
          ></Input>
          <FormErrorMessage>
            <>{methods.formState.errors?.baseDiscountPercentage?.message}</>
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!methods.formState.errors.shippingAfter} mb={4}>
          <Input
            id="shippingAfter"
            placeholder="Date de livraison à minimum"
            defaultValue={value?.shippingAfter ?? 'P0000-00-00T00:00:00'}
            {...methods.register("shippingAfter", {
              required: "Ce champ est obligatoire",
            })}
          ></Input>
          <FormErrorMessage>
            <>{methods.formState.errors?.shippingAfter?.message}</>
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!methods.formState.errors.upsSageId} mb={4}>
          <Input
            id="upsSageId"
            placeholder="UPS (Sage ID)"
            defaultValue={value?.upsSageId}
            {...methods.register("upsSageId", {
              required: "Ce champ est obligatoire",
            })}
          ></Input>
          <FormErrorMessage>
            <>{methods.formState.errors?.upsSageId?.message}</>
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!methods.formState.errors.upsShippingPrice} mb={4}>
          <Input
            id="upsShippingPrice"
            placeholder="UPS (Prix de livraison)"
            defaultValue={value?.upsShippingPrice ? value.upsShippingPrice / 100 : 0}
            {...methods.register("upsShippingPrice", {
              required: "Ce champ est obligatoire",
            })}
          ></Input>
          <FormErrorMessage>
            <>{methods.formState.errors?.upsShippingPrice?.message}</>
          </FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={!!methods.formState.errors.printingServiceAddress}>
          <Input
            id="printingServiceAddress"
            placeholder="Adresse service impression"
            defaultValue={value?.printingServiceAddress}
            {...methods.register("printingServiceAddress", {
              required: "Ce champ est obligatoire",
            })}
          ></Input>
          <FormErrorMessage>
            <>{methods.formState.errors?.printingServiceAddress?.message}</>
          </FormErrorMessage>
        </FormControl>
      </form>
    </FormProvider>
  );
});

export default AdminSettingsForm;
